export default {
  title: 'Instructional Design · Document',
  breadcrumb: 'Instructional Design Document',
  openButton: 'View as document',
  openTooltip:
    'See the whole Instructional Design as a document: each Module’s path with its pieces, the triangulation and the calendar.',
  backToDesign: 'Back to the Instructional Design',
  print: 'Print',
  loadError: 'The Instructional Design document could not be loaded.',
  noInstrument: 'No instrument',
  noEvaluations: 'This design has no evaluations yet.',

  identityTitle: 'The subject and the design',
  summaryTitle: 'Design summary',
  pathTitle: 'The path',
  showTexts: 'Include each piece’s texts',
  unitsTitle: 'Triangulation by Unit',
  weeklyTitle: 'Calendar',
  schemeTitle: 'Evaluations',
  bibliographyTitle: 'Bibliography',

  fieldCode: 'Code',
  fieldProfile: 'Programme',
  fieldPlanLevel: 'Level',
  fieldCredits: 'Credits',
  fieldWeeks: 'Weeks',
  fieldModality: 'Modality',
  fieldMethod: 'Instructional model',

  counterModules: 'Modules',
  counterActivities: 'Activities',
  counterEvaluations: 'Evaluations',
  counterHours: 'Assigned / Programme hours',
  counterAutonomous: 'Autonomous work hours',
  counterWeighing: 'Weighting',

  moduleUntitled: 'Module {order}',
  moduleMeta: '{pieces} pieces · {hours} h · {weighing}%',
  moduleEmpty: 'This Module has no pieces yet.',
  loosePieces: 'Pieces without a Module',
  pathEmpty: 'This design has no pieces yet.',

  rowStrategies: 'Taught with',
  rowEvidences: 'Leaves as evidence',
  rowEnvironments: 'Environment',
  rowResources: 'Resources',
  rowBibliography: 'Bibliography',
  rowContents: 'Contents',
  rowParticipation: 'Participation',

  textDescription: 'What it is about',
  textOrientation: 'Orientation',
  textStudent: 'Instructions for the student',
  textProfessor: 'Instructions for the teacher',

  unitMeta: '{activities} Activities · {evaluations} Evaluations',
  unitMoments: 'Moments covered',
  unitShared: 'Coherence',
  unitNoIndicators: 'This Unit has no Indicators recorded.',
  sharedStrategies: 'Taught and assessed with {names}',
  noSharedStrategies:
    'What is taught and what is assessed share no strategy',
  sharedEvidences: 'Produces and collects {names}',
  noSharedEvidences:
    'The evidence produced is not the one that is collected',
  notComparable:
    'Strategies or evidence are missing on one of the two sides, so there is nothing to compare yet',

  diagnosis_triangulado: 'Triangulated',
  diagnosis_se_evalua_sin_trabajarse: 'Assessed but not worked on',
  diagnosis_se_trabaja_sin_evaluarse: 'Worked on but not assessed',
  diagnosis_sin_trabajar_ni_evaluar: 'Neither worked on nor assessed',

  colIndicator: 'Indicator',
  colWorkedBy: 'Worked on in',
  colAssessedBy: 'Assessed in',
  colDiagnosis: 'Status',
  colWeek: 'Week',
  colContainer: 'Module / Unit',
  colPiece: 'Activity / Evaluation',
  colHours: 'Hours',
  colMoments: 'Moments',
  colPieces: 'Activities and Evaluations',
  colEvaluation: 'Evaluation',
  colUnitWeek: 'Unit / Week',
  colCharacter: 'Character',
  colStudentEvidence: 'Student evidence',
  colInstrument: 'Instrument',
  colAgent: 'Agent / Modality',
  colWeighing: 'Weighting',

  noMoment: 'No moment',
  noMethod: 'The design has no instructional model selected',
  week: 'W{week}',
  weekRange: 'W{from}-{to}',
  weekNone: 'n/w',
  hoursShort: '{hours} h',
  autonomousShort: '{hours} autonomous h',
  studentsShort: '{students} students',
  attempts: '{attempts} attempt(s)',
  withRubric: 'with rubric',
  maxScore: '{score} pts',
  total: 'Total',
  hoursNote:
    'The week is not stored: it comes from accumulating the design’s hours in order. The Subject declares {total} hours over {weeks} weeks, that is {weekly} per week.',
}
